export default __webpack_public_path__ + "static/media/movipack_feature3.515e86cc.svg";